export const SET_ALERTPROFILES = 'SET_ALERTPROFILES';
export const ADD_ALERTPROFILES = 'ADD_ALERTPROFILES';
export const ALERTPROFILE_ERROR = 'ALERTPROFILE_ERROR';
export const SET_ALERTPROFILE = 'SET_ALERTPROFILE'

function handleResponse(response) {
  if (response.ok) {
    return response.json();
  } else {
    let error = new Error(response.statusText);
    error.response = response.statusText;
    throw error;
  }
}


export function set(results) {
  return {
    type: SET_ALERTPROFILES,
    results
  }
}
export function setone(results) {
  return {
    type: SET_ALERTPROFILE,
    results
  }
}
export function add(results) {
  return {
    type: ADD_ALERTPROFILES,
    results
  }
}
export function itemError(error) {
  return {
    type: ALERTPROFILE_ERROR,
    payload: error
  };
}

export function Savealertprofile(data) {
  return dispatch => {
    return fetch('/api/admin/alertprofile', {
      method: 'post',
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem('token')
      }
    }).then(handleResponse).then(results => {
      return dispatch(add(results));
    }).catch((err) => {
      console.log(err);
      return dispatch(itemError('Er is een fout opgetreden bij het insert database'));
    });
  };
}

export function editalertprofile(id, data) {
  return dispatch => {
    return fetch('/api/admin/alertprofile/'+id, {
      method: 'post',
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem('token')
      }
    }).then(handleResponse).then(results => {
      return dispatch(add(results));
    }).catch((err) => {
      return dispatch(itemError('Er is een fout opgetreden bij het insert database'));
    });
  };
}

export function fetchalertprofiles() {
  return dispatch => {
    return fetch('/api/admin/alertprofile/', {
      method: 'get',
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem('token')
      }
    }).then(handleResponse).then(results => {
      return dispatch(set(results.results));
    }).catch((err) => {
      return dispatch(itemError('Er is een fout opgetreden bij het insert database'));
    });
  };
}

export function getalertprofile(id) {
  return dispatch => {
    return fetch('/api/admin/alertprofile/'+id, {
      method: 'get',
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem('token')
      }
    }).then(handleResponse).then(results => {
      return dispatch(setone(results.results));
    }).catch((err) => {
      return dispatch(itemError('Er is een fout opgetreden bij het insert database'));
    });
  };
}
